<!--
     DESKTOP
-->
<!-- *ngIf="browsersniffer.isPhone" -->
<!-- @if(!browsersniffer.isPhone()){  -->
<div class="legend-button-container" [hidden]="browsersniffer.isPhone()">
    <button mat-mini-fab  class="map-control-button" aria-label="Legend" color="none" [ngClass]="{'active': isOpen()}" (click)="toggle()"
        [matTooltip]="'legendTxt.showlegend' | translate" matTooltipPosition="left">
        <mat-icon fontSet="ngi" fontIcon="tree-deciduous"></mat-icon>
    </button>
</div>
 <!-- }  -->
<div class="tt-legend-drawer " [@openClose]="!isOpen() ? 'close' : 'open'">
    <div class="tt-legend-drawer-inner">
        <button matIconButton type="button" class="close" (click)="close()"  ><mat-icon>arrow_forward</mat-icon></button>
        <div class="legend-header flex-container container-space-between column" tabindex="-1">
            <h4 class="">{{ 'legendTxt.title' | translate }}
            </h4>
            <div class="list-sub-header" [innerHTML]="activeLayerLabel"></div>
        </div>   
        <div>
            <ng-container *ngTemplateOutlet="legendTemplate"></ng-container>
        </div>
    </div>
</div>

<ng-template #legendTemplate>
    <div class="legend-wrapper">
        <ng-container #legendContainer class="legend-container"></ng-container>
    </div>
</ng-template>